import Vue from 'vue';
import firebase from '../../firebase/firebase';
import * as cloneDeep from 'lodash.clonedeep';
const db = firebase.firestore();

const defaultProductInfo = {
    description : '',
    details : '',
    dispatched : true,
    enabled : true,
    express : false,
    image : '',
    productType : {
        description : '',
        id : '',
        menuId: ''
    },
    stock : {
        enabled : false,
        quantity : 1
    },
    updatedAt : Date.now(),
    value : 0,
    options : {

    },
    fiscal : {

    }
}

export default {
    namespaced: true,

    state: {
        products: {},
        productInfo : {...cloneDeep(defaultProductInfo)},
        tempImageBase64: '',
        tempImage: '',
    },

    actions: {
        async fetchProducts ({ state, rootGetters, commit }, { productId, force}) {
            if (!force && state.products[productId])
                return;
            const companyId = rootGetters.getCompanyID;
            const productSnap = await db.collection(`company/${companyId}/products`).doc(productId).get();
            if (!productSnap.exists)
                throw new Error('Produto inválido!');
            commit('setProduct', { id: productSnap.id, product: productSnap.data() });
        }
    },

    mutations: {
        setTempImage(state, tempImage) {
          state.tempImage = tempImage
        },
        setProduct(state, { id, product }) {
            Vue.set(state.products, id, { ...product, id });
        },
        setProductInfo (state, productInfo) {
            state.productInfo = productInfo
        },
        setDescription(state, description) {
            Vue.set(state.productInfo, 'description', description)
        },
        setImage(state, image) {
            Vue.set(state.productInfo, 'image', image)
        },
        setDetails(state, details) {
            Vue.set(state.productInfo, 'details', details)
        },
        setMenu(state, menuId) {
            Vue.set(state.productInfo, 'productType', {
                id : '',
                description : '',
                menuId : menuId
            })
        },
        setProductType(state, pType) {
            Vue.set(state.productInfo, 'productType', {...pType})
        },
        setDispatched(state, dispatched) {
            Vue.set(state.productInfo, 'dispatched', dispatched)
        },
        setEnabled(state, enabled) {
            Vue.set(state.productInfo, 'enabled', enabled)
        },
        setExpress(state, express) {
            Vue.set(state.productInfo, 'express', express)
        },
        setStockEnabled(state, enabled) {
            if(!state.productInfo.stock)
                Vue.set(state.productInfo, 'stock', {})
            Vue.set(state.productInfo.stock, 'enabled', enabled)
        },
        setStockQuantity(state, quantity) {
            if(!state.productInfo.stock)
                Vue.set(state.productInfo, 'stock', {})
            Vue.set(state.productInfo.stock, 'quantity', quantity)
        },
        setProductValue(state, value) {
            Vue.set(state.productInfo, 'value', value)
        },
        setSizeDescription(state, { desc, i }) {
            Vue.set(state.productInfo.options.size.items[i], 'size', desc)
        },
        setSizeObj(state, obj) {
            Vue.set(state.productInfo.options, 'size', obj)
        },
        setSizeItemObj(state, {randKey, obj}) {
            Vue.set(state.productInfo.options.size.items, randKey, obj)
        },
        removeItemSize(state, key) {
            Vue.delete(state.productInfo.options.size.items, key)
        },
        removeSizeOption(state) {
            Vue.delete(state.productInfo.options, 'size')
        },
        setSizeUnit(state, { val, i }) {
            Vue.set(state.productInfo.options.size.items[i], 'unit', val)
        },
        setSizePrice(state, { val, i }) {
            Vue.set(state.productInfo.options.size.items[i], 'value', val)
        },
        setProductOption(state, options) {
            Vue.set(state.productInfo, 'options', options)
        },
        setComercialUnit(state, unit) {
            if(!state.productInfo.hasOwnProperty('fiscal'))
                Vue.set(state.productInfo, 'fiscal', {})
            Vue.set(state.productInfo.fiscal, 'unidadeComercial', unit)
        },
        setTaxUnit(state, unit) {
            if(!state.productInfo.hasOwnProperty('fiscal'))
                Vue.set(state.productInfo, 'fiscal', {})
            Vue.set(state.productInfo.fiscal, 'unidadeTributavel', unit)
        },
        setCFOP(state, CFOP) {
            Vue.set(state.productInfo.fiscal, 'CFOP', CFOP)
        },
        setCSOSN(state, CSOSN) {
            Vue.set(state.productInfo.fiscal, 'CSOSN', CSOSN)
        },
        setNCM(state, NCM) {
            Vue.set(state.productInfo.fiscal, 'NCM', NCM)
        },
        setCEAN(state, cEAN) {
            Vue.set(state.productInfo.fiscal, 'cEAN', cEAN)
        },
        setProductCod(state, cod) {
            state.productInfo.cod = cod
        },
        clearProductInfo(state) {
            state.productInfo = { ...cloneDeep(defaultProductInfo) }
            state.tempImageBase64 = ''
        },
        setProductId(state, id) {
            Vue.set(state.productInfo, 'id', id)
        },
        setTempImageBase64(state, base64) {
          state.tempImageBase64 = base64
        }
    }
}
